<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import MlTabs, {type Tab} from "@/components/molecules/MlTabs/MlTabs.vue";
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";

const {t} = useI18n();
const route = useRoute();
const router = useRouter();

const activeTab = computed(() => String(route.name));
const tabs = computed(() => {
  return [{ name: 'AI Documents', value: 'userUploadsAiDocuments',}, {name: 'Data Sheets', value: 'userUploadsDataSheets'} ];
});


</script>

<template>
  <div class="pt-5 px-6 flex flex-col">
    <div class="flex-1">
      <!-- Page title & actions -->
      <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
        {{ t('User Uploads') }}
      </h1>

      <MlTabs
          class="mt-3"
          :modelValue="activeTab"
          :tabs="tabs"
          isEdgeToEdge
          @update:modelValue="
        router.push({ name: $event.value, query: $event.query })
      "
      >
      </MlTabs>

      <section ref="sectionRef" class="mt-10">
        <router-view/>
      </section>

    </div>
  </div>
</template>
